import { useCallback } from "react";

import { styled } from "@linaria/react";
import { match } from "ts-pattern";

import { PropsWithTheme, withTheme } from "@gx/dls/theme";

import EditSourceArtifacts from "@/pages/sources/components/edit/tabs/artifacts/EditSourceArtifacts";
import EditSourceContent from "@/pages/sources/components/edit/tabs/content/EditSourceContent";
import EditSourceOverview from "@/pages/sources/components/edit/tabs/overview/EditSourceOverview";
import EditSourceSettings from "@/pages/sources/components/edit/tabs/settings/EditSourceSettings";
import EditSourceSyncs from "@/pages/sources/components/edit/tabs/syncs/EditSourceSyncs";
import { EditSourceDrawerTab } from "@/pages/sources/components/edit/types";

interface EditSourceDrawerBodyProps {
  activeTab: EditSourceDrawerTab;
  onClose?: () => void;
}

const EditSourceDrawerBodyWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.background.base};
`);

const EditSourceDrawerBody = ({ activeTab, onClose }: EditSourceDrawerBodyProps) => {
  const renderTab = useCallback(
    (): React.ReactNode =>
      match(activeTab)
        .with(EditSourceDrawerTab.OVERVIEW, () => <EditSourceOverview />)
        .with(EditSourceDrawerTab.SYNCS, () => <EditSourceSyncs />)
        .with(EditSourceDrawerTab.CONTENT, () => <EditSourceContent />)
        .with(EditSourceDrawerTab.ARTIFACTS, () => <EditSourceArtifacts />)
        .with(EditSourceDrawerTab.SETTINGS, () => <EditSourceSettings onClose={onClose} />)
        .exhaustive(),
    [activeTab, onClose],
  );

  return <EditSourceDrawerBodyWrapper>{renderTab()}</EditSourceDrawerBodyWrapper>;
};

export default EditSourceDrawerBody;
